
raymont.videoPlayer = function() { 

      // 2. This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onYouTubeIframeAPIReady() {
  
      player = new YT.Player('player', { 
      height: '390',
      width: '640',
      host: 'https://www.youtube.com',
      videoId: $('#player')["0"].dataset.videoid,
      playerVars: {
        showinfo: '0',
        modestbranding: '1',
        controls:'0',
        rel: '0',
        showinfo: '0',
        loop: '1',
        autoplay: '1'
       
    },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  }

  function onPlayerReady() {
    player.mute();
    player.playVideo();
  }

  function onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.ENDED) {
        player.playVideo(); 
    }
}